"use client";
import React from "react";
import { CircledIcon } from "../CircledIcon";
import FacebookIcon from "@/assets/icons/logo-facebook.svg";
import TwitterIcon from "@/assets/icons/logo-twitter.svg";
import LinkedinIcon from "@/assets/icons/logo-linkedin.svg";
import MailIcon from "@/assets/icons/logo-mail.svg";
import EndemicLogo from "@/assets/icons/endy/endy-empty.svg";
import { twMerge } from "tailwind-merge";
import Link from "next/link";
import {
  getFacebookShareLink,
  getTwitterShareLink,
  getLinkedInShareLink,
  openLinkInDialog,
  getEndemicShareLink,
} from "@/shared/social";
import { getMailShareLink } from "../../../../shared/social";

export interface Props {
  className?: string;
  route: string;
  title?: string;
}

const VerticalShareSection = ({ className, route, title }: Props) => {
  const handleFacebookShareClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openLinkInDialog(getFacebookShareLink(route));
  };

  return (
    <div
      className={twMerge(className, "flex lg:flex-col gap-40 justify-center")}
    >
      <div className="flex lg:flex-col gap-4 justify-center">
        <Link href={getEndemicShareLink(route)}>
          <CircledIcon
            className="bg-endemicGray-50 hover:bg-red hover:fill-white border-none endemic:hover:bg-yellow"
            icon={
              <EndemicLogo className="w-6 h-6 fill-black hover:fill-white" />
            }
          ></CircledIcon>
        </Link>

        <Link
          href={getFacebookShareLink(route)}
          onClick={handleFacebookShareClick}
          target="_blank"
          rel="noopener noreferrer"
        >
          <CircledIcon
            className="bg-endemicGray-50 hover:bg-red hover:fill-white border-none endemic:hover:bg-yellow"
            icon={<FacebookIcon className="w-4 h-4" />}
          ></CircledIcon>
        </Link>
        <Link href={getTwitterShareLink(route)} target="_blank">
          <CircledIcon
            className="bg-endemicGray-50 hover:bg-red hover:fill-white border-none endemic:hover:bg-yellow"
            icon={<TwitterIcon className="w-4 h-4" />}
          ></CircledIcon>
        </Link>
        <Link href={getLinkedInShareLink(route)} target="_blank">
          <CircledIcon
            className="bg-endemicGray-50 hover:bg-red hover:fill-white border-none endemic:hover:bg-yellow"
            icon={<LinkedinIcon className="w-4 h-4" />}
          ></CircledIcon>
        </Link>
        <Link href={getMailShareLink(route, title)} target="_blank">
          <CircledIcon
            className="bg-endemicGray-50 hover:bg-red hover:fill-white border-none endemic:hover:bg-yellow"
            icon={<MailIcon className="w-4 h-4" />}
          ></CircledIcon>
        </Link>
      </div>
      <div className="hidden lg:flex text-body-2 relative text-[#A7A9AC] endemic:text-primary -rotate-90 lg:before:content-[''] lg:before:block lg:before:h-[1px] lg:before:w-30 lg:before:bg-endemicGray-500 endemic:lg:before:bg-primary lg:before:absolute lg:before:left-[70px] lg:before:top-[14px] lg:before:w-28">
        Share:
      </div>
    </div>
  );
};

export default VerticalShareSection;
